// src/pages/Pricing.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: '3rem 2rem',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: "'Open Sans', sans-serif"
      }}
    >
      {/* Content for Pricing page will go here */}

      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <button
          onClick={() => navigate('/signup')}
          style={{
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            backgroundColor: '#14B1E7',
            color: '#000',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Sign Up Now
        </button>
      </div>
    </div>
  );
};

export default Pricing;
